<template>
  <div id="dashboard-wise">
    <div class="page-header-wise">
      <div>
        <div>
          <div class="page-header-wise-title">
            <h4>Dashboard</h4>
            <h4>
              Perfil: <span class="profileName">{{ userData.name }}</span>
            </h4>
            <span
              >Controle a quantidade de mensagens enviadas e o status de conexão
              do seu aparelho.</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="body">
      <div class="card-wise-connection-body">
        <div
          :class="[
            'card-wise',
            connectionStatus.clientConnected ? 'bg-c-green' : 'bg-c-red',
          ]"
          @click="
            $router.push({
              name: 'connection_wise',
            })
          "
        >
          <div>
            <div class="col-auto">
              <span>QR CODE</span>
            </div>
            <div
              :id="
                connectionStatus.clientConnected
                  ? 'con-status-1'
                  : 'con-status-2'
              "
              class="text-right"
            >
              <h4 class="m-b-5 text-white">Status de Conexão</h4>
              <h2 class="m-b-5 text-white">
                {{
                  connectionStatus.clientConnected
                    ? 'Conectado'
                    : 'Desconectado'
                }}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div class="card-wise-container">
        <div
          v-for="(item, index) in cardData"
          :key="index"
          class="card-wise card-wise-dashboard"
        >
          <h4>{{ item.title }}</h4>
          <h6 :class="['m-b-0', 'sub-title-wise', item.color]">
            {{ item.subTitle }}
          </h6>
          <div>
            <div>
              <h3 class="m-b-0">{{ item.info }}</h3>
            </div>
          </div>
        </div>
        <!-- FILA -->
        <queue-status
          :status-queue="(userData && userData.statusQueue) || false"
          :user-data="userData"
        />

        <!-- ENVIO EXPRESSO -->
        <express-shipping />

        <!-- ATUALIZAR DADOS -->
        <update-user-data-wise />
      </div>
      <div>
        <queue-table :queueItems="queue" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import queueStatus from './components/queueStatus.vue';
import expressShipping from './components/expressShipping.vue';
import queueTable from './components/queueTable.vue';
import updateUserDataWise from './components/updateUserDataWise.vue';
export default {
  components: { queueStatus, expressShipping, queueTable, updateUserDataWise },
  computed: {
    ...mapGetters({
      userData: 'getUserData',
      connectionStatus: 'getConnectionStatus',
      queue: 'getQueue',
    }),
    cardData() {
      if (!this.userData || Object.keys(this.userData).length === 0) return [];
      return [
        {
          title: 'Seu Plano',
          subTitle: 'Limite de Mensagens',
          info: this.userData.messageLimit,
          color: 'text-c-red',
        },
        {
          title: 'Mensagens Enviadas',
          subTitle: 'Contagem Mensal',
          info: this.userData.messageSent,
          color: 'text-c-green',
        },
        {
          title: 'Mensagens Restantes',
          subTitle: 'Controle de Mensagens',
          info: this.userData.messageLimit - this.userData.messageSent,
          color: 'text-c-yellow',
        },
        {
          title: 'Mensagens na Fila',
          subTitle: 'Controle de Mensagens',
          info: this.queue.length || 0,
          color: 'text-c-yellow',
        },
      ];
    },
  },
};
</script>

<style scoped>
#dashboard-wise {
  background-color: #f2f7fb;
  font-size: 0.9375rem;
  overflow-x: hidden;
  color: #333;
  font-family: open sans, sans-serif;
  background-image: linear-gradient(rgba(255 255 255 / 0%) 240px, #f2f7fb 0%);
  padding: 50px 0;
  height: 100vh;
}
*:focus {
  outline: none;
}

a {
  font-size: 13px;
  color: #37474f;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-outf;
}
.card-wise {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card-wise .card-wise-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.card-wise .card-wise-header.borderless {
  border-bottom: 0 solid transparent;
}

.card-wise .card-wise-header.borderless + .card-wise-block,
.card-wise .card-wise-header.borderless + .card-wise-block-big,
.card-wise .card-wise-header.borderless + .card-wise-block-small {
  padding-top: 0;
}

h4,
h2,
h6,
h3 {
  padding: 0;
  margin: 0;
  font-weight: 500;
  font-size: 16px;
}
h2 {
  font-size: 26px;
  font-weight: bold;
}
h6 {
  font-size: 13px;
}
.page-header-wise {
  margin: 0 50px;
}
.page-header-wise-title {
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  font-size: 26px;
  font-weight: 400;
  margin-bottom: 30px;
  border-radius: 8px;
}
.page-header-wise-title span {
  font-size: 13px;
}
.sub-title-wise {
  border-bottom: 1px solid rgba(204, 204, 204, 0.35);
  padding-bottom: 10px;
  margin-bottom: 20px;
  font-size: 14px;
  font-weight: 400;
  color: black;
}
.card-wise-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 30px;
}

.card-wise {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-wise-dashboard {
  background-color: white;
  margin: 0;
  flex: 0 0 calc((100% - 40px) / 3);
  max-width: calc((100% - 40px) / 3);
  height: 140px;
}
.card-wise-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.card-wise-type {
  padding: 15px 0;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.addFlowWise {
  display: flex;
  justify-content: center;
}
.saveFlowWise {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info,
.profileName {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}

.bg-c-red {
  background: #ff5370;
}
.text-c-red {
  color: #ff5370;
}
.bg-c-green {
  background: #2ed8b6;
}
.text-c-green {
  color: #2ed8b6;
}
.bg-c-yellow {
  background: #ffb64d;
}
.text-c-yellow {
  color: #ffb64d;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-b-0 {
  margin-bottom: 0;
}
.body {
  padding: 0 40px 0 100px;
}

.text-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: white;
  margin-right: 40px;
}

.page-header-wise-card {
  display: flex;
}
.profileName {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
}
.card-wise-connection-body {
  cursor: pointer;
}
</style>
